/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFold = createReactComponent("outline", "fold", "IconFold", [["path", { "d": "M12 3v6l3 -3m-6 0l3 3", "key": "svg-0" }], ["path", { "d": "M12 21v-6l3 3m-6 0l3 -3", "key": "svg-1" }], ["path", { "d": "M4 12l1 0", "key": "svg-2" }], ["path", { "d": "M9 12l1 0", "key": "svg-3" }], ["path", { "d": "M14 12l1 0", "key": "svg-4" }], ["path", { "d": "M19 12l1 0", "key": "svg-5" }]]);

export { IconFold as default };
//# sourceMappingURL=IconFold.mjs.map
